import * as React from 'react'

import { useTheme } from '@emotion/react'
import styled from '@emotion/styled'

import { ICONS } from './Icon'

const IconWrapper = styled.div`
  font-size: 1.5rem;
  width: 1em;
  height: 1em;
  color: ${props => props.theme.colors.icon};

  display: flex;
  justify-content: center;
  align-items: center;
`

const SendIcon = (props: React.SVGAttributes<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M13.009 7.614l.001-.001.006-.005.023-.02a41.908 41.908 0 01.415-.368c.27-.236.618-.531.946-.792 1.634-1.296 3.685-1.22 5.042.136 1.36 1.36 1.475 3.778-.042 5.422-.972 1.053-2.753 2.762-4.44 4.207-.843.722-1.634 1.354-2.27 1.796a7.671 7.671 0 01-.69.438 7.676 7.676 0 01-.691-.438c-.637-.443-1.429-1.075-2.272-1.797-1.687-1.444-3.468-3.153-4.438-4.205-1.515-1.645-1.401-4.064-.042-5.423 1.357-1.357 3.41-1.432 5.045-.136a28.004 28.004 0 011.271 1.078l.09.081.024.02.005.006h.001v.001l1.008.914 1.008-.914zm-1.223 10.915h.003a.056.056 0 01-.003 0zm.426 0h.002-.002z"
      stroke="currentColor"
      strokeWidth={3}
    />
  </svg>
)

const HeartIcon = (props: React.SVGAttributes<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M13.009 7.614l.001-.001.006-.005.023-.02a41.908 41.908 0 01.415-.368c.27-.236.618-.531.946-.792 1.634-1.296 3.685-1.22 5.042.136 1.36 1.36 1.475 3.778-.042 5.422-.972 1.053-2.753 2.762-4.44 4.207-.843.722-1.634 1.354-2.27 1.796a7.671 7.671 0 01-.69.438 7.676 7.676 0 01-.691-.438c-.637-.443-1.429-1.075-2.272-1.797-1.687-1.444-3.468-3.153-4.438-4.205-1.515-1.645-1.401-4.064-.042-5.423 1.357-1.357 3.41-1.432 5.045-.136a28.004 28.004 0 011.271 1.078l.09.081.024.02.005.006h.001v.001l1.008.914 1.008-.914zm-1.223 10.915h.003a.056.056 0 01-.003 0zm.426 0h.002-.002z"
      stroke="currentColor"
      strokeWidth={3}
    />
  </svg>
)

const LightningIcon = (props: React.SVGAttributes<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M12.5 14l3.031-11.26c.132-.49-.464-.842-.83-.49L4.287 12.28c-.648.624-.206 1.72.694 1.72h7.52z"
      fill="currentColor"
    />
    <path
      d="M11.5 10L8.469 21.26c-.132.49.464.841.83.49l10.415-10.03c.648-.624.206-1.72-.694-1.72H11.5z"
      fill="currentColor"
    />
  </svg>
)

const ShieldIcon = (props: React.SVGAttributes<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 24" {...props}>
    <clipPath id="prefix__a">
      <path
        transform="matrix(1 0 0 -1 0 24)"
        d="M11 0c2.2 0 11 6 11 18 0 2-8.8 6-11 6-2.2 0-11-4-11-6C0 6 8.8 0 11 0z"
        fillRule="evenodd"
      />
    </clipPath>
    <g clipPath="url(#prefix__a)">
      <path
        d="M22 6h3-3zM11 27c.851 0 1.655-.262 2.256-.511a12.4 12.4 0 002.045-1.112c1.389-.918 2.916-2.244 4.338-3.968C22.502 17.939 25 12.779 25 6h-6c0 5.22-1.902 9.06-3.99 11.59-1.052 1.277-2.137 2.2-3.018 2.782a6.486 6.486 0 01-1.039.576c-.302.126-.254.052.047.052v6zM25 6c0-1.29-.664-2.245-1.056-2.726-.452-.556-1.007-1.038-1.533-1.44C21.348 1.022 20 .24 18.677-.428a36.518 36.518 0 00-4.019-1.74C13.542-2.568 12.131-3 11-3v6c-.031 0 .483.068 1.635.48 1.009.362 2.201.874 3.338 1.448 1.153.582 2.142 1.175 2.797 1.675.334.255.484.413.521.46C19.39 7.182 19 6.79 19 6h6zM11-3c-1.131 0-2.542.432-3.658.832a36.518 36.518 0 00-4.02 1.74C2.002.24.653 1.022-.41 1.834c-.526.402-1.08.884-1.533 1.44C-2.336 3.754-3 4.71-3 6h6c0 .79-.39 1.183-.291 1.062.037-.046.187-.204.521-.459.655-.5 1.644-1.093 2.797-1.675A30.538 30.538 0 019.365 3.48C10.517 3.068 11.03 3 11 3v-6zM-3 6c0 6.78 2.498 11.939 5.36 15.41 1.423 1.723 2.95 3.05 4.339 3.967a12.4 12.4 0 002.045 1.112c.6.25 1.405.511 2.256.511v-6c.301 0 .349.074.047-.052a6.485 6.485 0 01-1.04-.575c-.88-.583-1.965-1.506-3.018-2.782C4.902 15.06 3 11.22 3 6h-6z"
        fill="currentColor"
      />
    </g>
  </svg>
)

const CheckIcon = (props: React.SVGAttributes<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M5.5 12.5l4 4 9-9"
      stroke="currentColor"
      strokeWidth={3}
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

const SecurityIcon = (props: React.SVGAttributes<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.167 7c0 10-7.334 15-9.167 15-1.833 0-9.167-5-9.167-15 0-1.667 7.334-5 9.167-5 1.833 0 9.167 3.333 9.167 5zm-5.212 3.191a1.125 1.125 0 10-1.59-1.59l-3.58 3.579-1.15-1.15a1.125 1.125 0 00-1.59 1.592l1.944 1.944a1.125 1.125 0 001.591 0l4.375-4.375z"
      fill="currentColor"
    />
  </svg>
)

const DepositIcon = (props: React.SVGAttributes<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.94 8.44a1.5 1.5 0 012.12 2.12l-5 5a1.5 1.5 0 01-2.12 0l-5-5a1.5 1.5 0 012.12-2.12l2.44 2.439V2.5a1.5 1.5 0 013 0v8.379l2.44-2.44zM5.5 16a1.5 1.5 0 00-3 0v1.5A5.5 5.5 0 008 23h8a5.5 5.5 0 005.5-5.5V16a1.5 1.5 0 00-3 0v1.5A2.5 2.5 0 0116 20H8a2.5 2.5 0 01-2.5-2.5V16z"
      fill="currentColor"
    />
  </svg>
)

const TaxesDevices = (props: React.SVGAttributes<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M14 16V19" stroke="currentColor" strokeWidth="2.25" strokeLinecap="round" strokeLinejoin="round" />
    <line
      x1="11.125"
      y1="19.875"
      x2="16.875"
      y2="19.875"
      stroke="currentColor"
      strokeWidth="2.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6 4C4.89543 4 4 4.89543 4 6V7H7.5C8.88071 7 10 8.11929 10 9.5V16H21C22.1046 16 23 15.1046 23 14V6C23 4.89543 22.1046 4 21 4H6Z"
      fill="currentColor"
    />
    <rect x="1" y="9" width="7" height="12" rx="2" fill="currentColor" />
  </svg>
)

const ICON_LIST_ICONS = {
  ...ICONS,
  send: SendIcon,
  heart: HeartIcon,
  lightning: LightningIcon,
  shield: ShieldIcon,
  check: CheckIcon,
  security: SecurityIcon,
  deposit: DepositIcon,
  'taxes-devices': TaxesDevices,
} as const

const ListWrapper = styled.ul<{ space: string }>`
  padding: 0 0.5rem;
  margin: 0;
  display: grid;
  row-gap: ${props => props.space};
`

const ListItemWrapper = styled.li`
  display: flex;
  line-height: 1.5rem;
  color: ${props => props.theme.colors.secondaryLabel};

  div:first-child {
    margin-right: 1rem;
  }

  max-width: 31rem;
`

const ListItem = (props: { icon: keyof typeof ICON_LIST_ICONS; children: React.ReactNode }) => {
  const Icon = ICON_LIST_ICONS[props.icon]
  const theme = useTheme()

  return (
    <ListItemWrapper>
      <IconWrapper>
        <Icon color={theme.colors.icon} height="1em" width="1em" />
      </IconWrapper>
      {props.children}
    </ListItemWrapper>
  )
}

export type IconListItem = { icon: keyof typeof ICON_LIST_ICONS; content: React.ReactNode }

export default ({ items, space = '1.5rem' }: { items: IconListItem[]; space?: string }) => {
  return (
    <ListWrapper space={space}>
      {items.map(({ icon, content }, i) => (
        <ListItem icon={icon} key={i}>
          {content}
        </ListItem>
      ))}
    </ListWrapper>
  )
}
